import React from "react";
import classNames from "classnames";
import { BulletListSeparator } from "./enum";
import { BulletListItemProps, BulletListPropTypes } from "./types";

function BulletList(props: React.PropsWithChildren<BulletListPropTypes>) {
  if (React.Children.toArray(props.children)?.every(c => !c)) return null;

  return (
    <ul
      className={classNames("bullet_list", props.className, {
        "seperator--dot": props.separator === BulletListSeparator.DOT,
        "seperator--pipe": props.separator === BulletListSeparator.PIPE
      })}>
      {props.children}
    </ul>
  );
}

BulletList.Item = function (props: BulletListItemProps) {
  return (
    <li className={classNames("bullet_list_item", props.className)}>
      {props.icon && (
        <span
          className={classNames("bullet_list_item--icon", {
            [`${props.className}--icon`]: props.className
          })}>
          {props.icon}
        </span>
      )}
      <span
        className={classNames("bullet_list_item--text", {
          [`${props.className}--text`]: props.className
        })}
        title={typeof props.text === "string" ? props.text : undefined}>
        {props.text}
      </span>
    </li>
  );
};

export default BulletList;
